import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
const HealthBannerLogo = ({ logo, alt, src }) => {
    if (!logo) {
        return _jsx(_Fragment, {});
    }
    const image = _jsx("img", { className: "healthbanner__logo", src: logo, alt: alt });
    if (!src) {
        return image;
    }
    return (_jsx("a", { className: "healthbanner__logo-url", href: src, children: image }));
};
export default HealthBannerLogo;
//# sourceMappingURL=HealthBannerLogo.js.map